"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createRouter", {
    enumerable: true,
    get: function() {
        return createRouter;
    }
});
const createRouter = function(router) {
    const newRouter = {};
    Object.entries(router).map((param)=>{
        let [k, v] = param;
        if (newRouter[k]) {
            throw new Error("Duplicate key found: ".concat(k, ", ").concat(v.constructor.name));
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        newRouter[k] = function() {
            for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                data[_key] = arguments[_key];
            }
            const view = new v(...data);
            view.key = k;
            return view;
        };
        newRouter[k].toString = function() {
            return k;
        };
    });
    return newRouter;
};
